import { apiGet, apiPost } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmDelegateType } from '../interfaces/IKnmDelegateType';

export async function fetchKnmDelegateTypes(): Promise<IKnmDelegateType[]> {
  return apiGet<IKnmDelegateType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-delegate-types`);
}

export async function createKnmDelegateType(knmDelegateType: Omit<IKnmDelegateType, 'id'>): Promise<void> {
  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-delegate-types`,
    body: knmDelegateType,
  });
}

export async function updateKnmDelegateType(knmDelegateType: IKnmDelegateType): Promise<void> {
  const { id, ...data } = knmDelegateType;

  return apiPost({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-delegate-types/${id}`,
    body: data,
  });
}
